import { useState, useEffect } from 'react';
import { tumblerBetaRegions, tumblerGammaRegions, tumblerProdRegions } from '../../../pages/Home/Navbar/RegionSwitch';

const stageMapping = {
  'beta': 'staging',
  'gamma': 'integ',
  'prod': 'prod'
};

export function useDomainIdentuple(domainIdentifier: string) {
  const [domainIdentuple, setDomainIdentuple] = useState<string>('');
  
  useEffect(() => {
    const host = window.location.host;
    const currentRegion = host.split('.')[0];
    const currentStage = host.split('.')[1];
    
    let regionInfo;
    switch(currentStage) {
      case 'beta':
        regionInfo = tumblerBetaRegions.find(r => r.value.startsWith(currentRegion));
        break;
      case 'gamma':
        regionInfo = tumblerGammaRegions.find(r => r.value.startsWith(currentRegion));
        break;
      case 'prod':
        regionInfo = tumblerProdRegions.find(r => r.value.startsWith(currentRegion));
        break;
      default:
        regionInfo = tumblerProdRegions.find(r => r.value.startsWith('iad'));
    }
    
    const fullRegionName = regionInfo?.label.match(/\((.*?)\)/)?.[1] || 'us-east-1';
    const stageName = stageMapping[currentStage] || 'staging';
    
    const [accountId, domainName] = domainIdentifier.split(':');
    const path = `swift-${fullRegionName}-${stageName}/${accountId}/${domainName}/1`;
    
    setDomainIdentuple(path);
  }, [domainIdentifier]);
  
  return domainIdentuple;
}